<template>
  <div class="vch-product-details">
    <div class="vch-product-details__details-row">
      <div class="vch-product-details__product-img" v-if="productInfo">
        <img :src="productInfo.ProductImage" :alt="productInfo.ProductName" />
      </div>
      <div class="vch-product-details__product-details">
        <div class="mt-lg product-info">
          <!-- <span class="product-info__label heading-xxs bg-liftactiv mb-xs">
            Neu</span
          > -->
          <h2 class="product-info__name" v-if="productInfo">
            <span class="vch-product-details__productTitle">
              {{ productInfo.ProductName }}
            </span>
            <span class="vch-product-details__productSubTitle">
              {{ productInfo.SubTitle }}
            </span>
          </h2>
        </div>
        <div class="mt-sm" v-if="productInfo">
          <rr-star-ratings>
            <div class="bvInlineRating productHeader">
              <div>
                <div
                  data-bv-show="rating_summary"
                  :data-bv-product-id="productInfo.ProductId"
                ></div>
              </div>
            </div>
          </rr-star-ratings>
        </div>
        <div class="vch-product-details__titles">
          <p class="heading-xs">{{ secondTitle }}</p>
          <p class="heading-xxs mt-xs">{{ secondDescription }}</p>
        </div>
        <div class="vch-product-details__variant-row mt-xxs">
          <div v-if="!shadesSelector && sizeSelectorItems.length !== 0">
            <VchPackageSizeSelector
              :options="sizeSelectorItems"
              :defaultOption="defaultValue"
              :productItemId="selectedVariant"
              :varintItemId="selectedVariant"
              class="mb-xs"
              ref="sizeSelector"
              :modalOpen="modalOpen"
            >
            </VchPackageSizeSelector>
          </div>
          <div v-if="shadesSelector">
            <div class="vch-shade-selector" style="z-index: 0 !important">
              <fieldset>
                <legend class="sr-only">Shades</legend>
                <vch-scroller
                  :radio-scroller="true"
                  style="opacity: 1; z-index: 0 !important"
                >
                  <ul class="vch-slider__list" v-if="productInfo">
                    <li
                      class="vch-slider__item shade-swatch"
                      v-for="variants in productInfo.Varients"
                      :key="variants.Ean"
                    >
                      <input
                        class="sr-only"
                        type="radio"
                        :id="variants.ShadeNumber"
                        name="selected-shade"
                        checked="checked"
                        v-vch-variant-selector="{
                          ean: '{{variants.Ean}}',
                          shade: '',
                        }"
                      />
                      <label
                        :style="{ 'background-color': variants.HexCode }"
                        @click="handleSelectedShade(variants)"
                        @keypress="handleSelectedShade(variants)"
                        :for="variants.ShadeNumber"
                        :id="variants.ShadeNumber"
                        ><span class="sr-only"
                          >{{ variants.ShadeNumber }}&nbsp;{{
                            variants.ShadeName
                          }}</span
                        ></label
                      >
                    </li>
                  </ul>
                </vch-scroller>
              </fieldset>
              <p
                id="current-shade"
                class="heading-sm-em mt-sm uppercase"
                v-if="selectedVariant && selectedVariant.ShadeName"
              >
                {{ selectedVariant.ShadeNumber }} &nbsp;
                {{ selectedVariant.ShadeName }}
              </p>
            </div>
          </div>
        </div>
        <div>
          <button
            class="button -primary buy-btn mt-lg"
            @click="handleSelectedVariant"
          >
            WEITER
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { busName } from 'Directives/variant-selector/variant-selector';
import { pushData } from 'Utils/datalayer';
import VchPackageSizeSelector from '../../package-size-selector/package-size-selector.vue';
export default {
  name: 'vch-cc-modal-product-details',
  components: {
    VchPackageSizeSelector,
  },
  data() {
    return {
      shadesSelector: true,
      defaultValue: '',
      sizeSelectorItems: [],
      selectedVariant: null,
    };
  },
  props: {
    secondTitle: {
      type: String,
      required: true,
    },
    secondDescription: {
      type: String,
      required: true,
    },
    selectedCountry: {
      type: String,
      required: true,
    },
    productInfo: {
      type: Object,
      required: true,
    },
    modalOpen: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.handleData();
    this.$nextTick(() => {
      if (this.productInfo) {
        const shades = this.productInfo.Varients.map((item) => item.ShadeNumber);
        this.shadesSelector = shades.includes(0) ? false : true;
        if (this.shadesSelector) {
          this.selectedVariant =
            this.productInfo.Varients[this.productInfo.Varients.length - 1];
        } else {
          eventBus.$on(`${busName}::selected`, this.handleSizeSelectorData);
        }
      }
    });
    //this.selectOnLoad();
  },
  updated() {
    if (!this.shadesSelector) {
      eventBus.$on(`${busName}::selected`, this.handleSizeSelectorData);
      this.$nextTick(() => {
        this.handleSizeSelectorData();
      });
      this.closeListOnLoad();
    }
  },
  methods: {
    handleSizeSelectorData(data) {
      this.selectedVariant = data !== '' ? data : this.productInfo.Varients[this.productInfo.Varients.length - 1];
    },
    handleData() {
      if (this.productInfo) {
        const shades = this.productInfo.Varients.map(
          (item) => item.ShadeNumber
        );
        this.shadesSelector = shades.includes(0) ? false : true;

        if (!this.shadesSelector) {
          this.sizeSelectorItems = this.productInfo.Varients.map(
            ({ Ean, CommerceConnectorVariantName }) => {
              return {
                description: CommerceConnectorVariantName,
                ean: Ean,
              };
            }
          );
          if (!this.defaultValue) {
            this.defaultValue = this.sizeSelectorItems[0].description;
          }
          if (!this.selectedVariant) {
            this.selectedVariant = this.sizeSelectorItems[0].ean;
          }
          this.sizeSelectorItems = JSON.stringify(this.sizeSelectorItems);
        }
      }
    },
    handleSelectedShade(variant) {
      this.selectedVariant = variant;
    },
    handleSelectedShadeTagging(varient) {
      if (this.productInfo) {
        // Check if the desired value is present in the query string
        let dimension91Data;
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('prescripted')) {
          dimension91Data = urlParams.get('prescripted');
        }
        const shades = this.productInfo.Varients.map(
          (item) => item.ShadeNumber
        );
        this.shadesSelector = shades.includes(0) ? false : true;
        if (this.shadesSelector) {
          this.productInfo.Varients.map(
            ({ Ean, CommerceConnectorVariantName, Name }) => {
              if (Ean == varient.Ean) {
                pushData({
                  event: 'uaevent',
                  event_name: 'view_item',
                  eventCategory: 'Ecommerce',
                  eventAction: 'Product Detail|Variant selection',
                  eventLabel: `${this.productInfo.ProductName?.toLowerCase()}::${Ean}::${CommerceConnectorVariantName.toLowerCase()}`,
                  product_info: `${this.productInfo.ProductName?.toLowerCase()}::${Ean}::${CommerceConnectorVariantName.toLowerCase()}`,
                  event_detail: 'variant selection',
                  ecommerce: {
                    detail: {
                      products: [
                        {
                          name: this.productInfo.ProductName?.toLowerCase(),
                          id: Ean,
                          brand:
                            this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                            this.productInfo.Varients[0].Countrie[0].Shops[0]
                              .Tagging.click.ecommerce.add.products[0].brand
                              ? this.productInfo.Varients[0].Countrie[0]
                                  .Shops[0].Tagging.click.ecommerce.add
                                  .products[0].brand
                              : 'VIC',
                          category:
                            this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                            this.productInfo.Varients[0].Countrie[0].Shops[0]
                              .Tagging.click.ecommerce.add.products[0].category
                              ? this.productInfo.Varients[0].Countrie[0]
                                  .Shops[0].Tagging.click.ecommerce.add
                                  .products[0].category
                              : 'hair care',
                          price: 'none',
                          variant: CommerceConnectorVariantName?.toLowerCase(),
                          dimension35:
                            this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                            this.productInfo.Varients[0].Countrie[0].Shops[0]
                              .Tagging.click.ecommerce.add.products[0]
                              .dimension35
                              ? this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging.click.ecommerce.add.products[0].dimension35.toLowerCase()
                              : 'none',
                          dimension36: CommerceConnectorVariantName
                            ? CommerceConnectorVariantName?.toLowerCase()
                            : 'none',
                          dimension38:
                            this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                            this.productInfo.Varients[0].Countrie[0].Shops[0]
                              .Tagging.click.ecommerce.add.products[0]
                              .dimension38
                              ? this.productInfo.Varients[0].Countrie[0]
                                  .Shops[0].Tagging.click.ecommerce.add
                                  .products[0].dimension38
                              : '0',
                          dimension48: Ean,
                          dimension59:
                            this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                            this.productInfo.Varients[0].Countrie[0].Shops[0]
                              .Tagging.click.ecommerce.add.products[0]
                              .dimension59
                              ? this.productInfo.Varients[0].Countrie[0]
                                  .Shops[0].Tagging.click.ecommerce.add
                                  .products[0].dimension59
                              : '0',
                          dimension91: dimension91Data
                            ? dimension91Data
                            : this.productInfo.Varients[0].Countrie[0]
                                .Shops[0] &&
                              this.productInfo.Varients[0].Countrie[0].Shops[0]
                                .Tagging.click.ecommerce.add.products[0]
                                .dimension91
                            ? this.productInfo.Varients[0].Countrie[0].Shops[0]
                                .Tagging.click.ecommerce.add.products[0]
                                .dimension91
                            : 'none',
                        },
                      ],
                      actionField: {
                        list: 'others',
                      },
                    },
                  },
                });
              }
            }
          );
        }
        if (!this.shadesSelector) {
          this.productInfo.Varients.map(
            ({ Ean, CommerceConnectorVariantName, Name }) => {
              if (Ean == varient) {
                pushData({
                  description: CommerceConnectorVariantName,
                  ean: Ean,
                  event: 'uaevent',
                  event_name: 'view_item',
                  eventCategory: 'Ecommerce',
                  eventAction: 'Product Detail|Variant selection',
                  eventLabel: `${this.productInfo.ProductName?.toLowerCase()}::${Ean}::${CommerceConnectorVariantName.toLowerCase()}`,
                  product_info: `${this.productInfo.ProductName.toLowerCase()}::${Ean}::${CommerceConnectorVariantName.toLowerCase()}`,
                  event_detail: 'variant selection',
                  ecommerce: {
                    detail: {
                      products: [
                        {
                          name: this.productInfo.ProductName?.toLowerCase(),
                          id: Ean,
                          brand:
                            this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                            this.productInfo.Varients[0].Countrie[0].Shops[0]
                              .Tagging.click.ecommerce.add.products[0].brand
                              ? this.productInfo.Varients[0].Countrie[0]
                                  .Shops[0].Tagging.click.ecommerce.add
                                  .products[0].brand
                              : 'VIC',
                          category:
                            this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                            this.productInfo.Varients[0].Countrie[0].Shops[0]
                              .Tagging.click.ecommerce.add.products[0].category
                              ? this.productInfo.Varients[0].Countrie[0]
                                  .Shops[0].Tagging.click.ecommerce.add
                                  .products[0].category
                              : 'hair care',
                          price: 'none',
                          variant: CommerceConnectorVariantName?.toLowerCase(),
                          dimension35:
                            CommerceConnectorVariantName?.toLowerCase(),
                          dimension36: 'none',
                          dimension38:
                            this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                            this.productInfo.Varients[0].Countrie[0].Shops[0]
                              .Tagging.click.ecommerce.add.products[0]
                              .dimension38
                              ? this.productInfo.Varients[0].Countrie[0]
                                  .Shops[0].Tagging.click.ecommerce.add
                                  .products[0].dimension38
                              : '0',
                          dimension48: Ean,
                          dimension59:
                            this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                            this.productInfo.Varients[0].Countrie[0].Shops[0]
                              .Tagging.click.ecommerce.add.products[0]
                              .dimension59
                              ? this.productInfo.Varients[0].Countrie[0]
                                  .Shops[0].Tagging.click.ecommerce.add
                                  .products[0].dimension59
                              : '0',
                          dimension91: dimension91Data
                            ? dimension91Data
                            : this.productInfo.Varients[0].Countrie[0]
                                .Shops[0] &&
                              this.productInfo.Varients[0].Countrie[0].Shops[0]
                                .Tagging.click.ecommerce.add.products[0]
                                .dimension91
                            ? this.productInfo.Varients[0].Countrie[0].Shops[0]
                                .Tagging.click.ecommerce.add.products[0]
                                .dimension91
                            : 'none',
                        },
                      ],
                      actionField: {
                        list: 'others',
                      },
                    },
                  },
                });
              }
            }
          );
          //this.sizeSelectorItems = JSON.stringify(this.sizeSelectorItems);
        }
      }
    },
    handleSelectedVariant() {
      if (this.selectedVariant === undefined) {
        this.selectedVariant = this.$children[this.$children.length - 1].$data.varintItemIds
      }
      if (this.shadesSelector) {
        this.$emit('variantSelect', this.selectedVariant.Ean);
      } else {
        eventBus.$on(`${busName}::selected`, this.handleSizeSelectorData);
        if (this.selectedVariant !== undefined) {
          this.handleSizeSelectorData(this.selectedVariant);
          this.$emit('variantSelect', this.selectedVariant);
        }
      }
      this.handleSelectedShadeTagging(this.selectedVariant);
    },
    selectOnLoad() {
      setTimeout(function () {
        if (
          document.querySelector(
            '.vchy-package-size-selector__list [aria-selected]'
          )
        ) {
          document
            .querySelector('.vchy-package-size-selector__list [aria-selected]')
            .click();
        }
      }, 200);
    },
    closeListOnLoad() {
      setTimeout(function () {
        let detailsTag = document.querySelector('.vchy-package-size-selector');
        if (detailsTag && detailsTag.tagName?.toLowerCase() === 'details') {
          detailsTag.removeAttribute('open');
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" src="./cc-modal-product-details.scss"></style>
